import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Grid, Header, Tab } from 'semantic-ui-react';
import { PageTitleCard, DateTimeUtils, Icon, TimestampFilters } from 'dyl-components';
import PhoneSystemDashboard from './PhoneSystemDashboard';
import SalesDashboard from './SalesDashboard';
import contactActions from 'actions/contacts';
import leadsActions from 'actions/leads';
import opportunitiesActions from 'actions/opportunities';
import './index.scss';
import CalendarToolBar from 'pages/Calendar/subcomponents/CalendarToolBar';
import { GetTimezone } from 'utils/TZDisplay';
import { getData, onToggleTimeUnit, useRangeCalendar } from 'shared/CustomDateRange/customDateRange';
import { useNavigate, useSearchParams } from 'react-router-dom';

const Dashboard = () => {
    const [activeTab, setActiveTab] = React.useState(0);
    const dispatch = useDispatch();
    const [params] = useSearchParams();

    const {
        timestamp,
        setTimestamp,
        isCustomDateRangeOpen,
        setCustomDateRangeOpen,
        userAuthTimezone,
        dateRange,
        setDateRange,
    } = useRangeCalendar(params);

    useEffect(() => {
        dispatch(contactActions.readRecentContacts({ limit: 5, page: 1, assigned_only: true }));
        dispatch(leadsActions.readLeads({ limit: 5, page: 1, assigned_only: true }));
        dispatch(opportunitiesActions.readOpportunities({ limit: 5, page: 1, assigned_only: true }));
    }, [dispatch]);
    const calendarRef = useRef(null);

    const [timeUnits, setTimeUnits] = useState("week");
    const [offset, setOffset] = useState(0);
    const [viewType, setViewType] = useState("list");
    const [calendarDate, setCalendarDate] = useState(
        DateTimeUtils.getUnixTime(
            DateTimeUtils.getCurrentDate(),
            DateTimeUtils.DATE_FORMAT,
            GetTimezone()
        )
    );
    const refreshCalendarDate = () => {
        const date = fullCalendarApiFunction("getDate");
        const unixDate = DateTimeUtils.getUnixTime(
            `${date.getUTCMonth() + 1
            }-${date.getUTCDate()}-${date.getUTCFullYear()}`,
            DateTimeUtils.DATE_FORMAT
        );
        setCalendarDate(unixDate);
    };
    const fullCalendarApiFunction = (name, params = []) => {
        const api = calendarRef.current.getApi();
        return api[name](...params);
    };

    const changeCalendarView = (option) => {
        const views = {
            day: "timeGridDay",
            week: "timeGridWeek",
            month: "dayGridMonth",
            year: "multiMonthYear",
        };
        fullCalendarApiFunction("changeView", [views[option]]);
    };
    const startTime = DateTimeUtils.getStartOf(calendarDate, timeUnits);
    const endTime = DateTimeUtils.getEndOf(calendarDate, timeUnits);
    const onDateRangeChange = (_, { value }) => {
        setDateRange(value);
    };
    const navigate = useNavigate()
    const isCustomeDateSelected = params.get("start")?.length > 0
    const startParams = params.get("start");
    const endParams = params.get("end");
    const paramDateRange = `${startParams ? DateTimeUtils.formatEpoch(startParams, DateTimeUtils.DATE_FORMAT) : ""} - ${endParams ? DateTimeUtils.formatEpoch(endParams, DateTimeUtils.DATE_FORMAT) : ""}`;
    return (
        <div className="Dashboard">
            <PageTitleCard title="Dashboard" />

            <Grid stackable stretched>
                <Grid.Row>
                    <Grid.Column width={8}>
                        <Tab
                            menu={{ color: 'primary', className: 'centered Dashboard__field-categories' }}

                            panes={[
                                { menuItem: 'Phone System' },
                                { menuItem: 'Sales' },
                            ]}
                            activeIndex={activeTab}
                            onTabChange={(_, { activeIndex }) => setActiveTab(activeIndex)}
                        />
                    </Grid.Column>

                    <Grid.Column width={8} textAlign="right">
                        <div className="Dashboard__Header">
                            <span className="Dashboard__HeaderDate">
                                <Icon size="large" className="fas fa-calendar-plus" color="blue" onClick={() => setCustomDateRangeOpen(true)} link />
                                <CalendarToolBar
                                    timeUnits={timeUnits}
                                    setTimeUnits={setTimeUnits}
                                    offset={offset}
                                    setOffset={setOffset}
                                    viewType={viewType}
                                    setViewType={setViewType}
                                    refreshCalendarDate={refreshCalendarDate}
                                    fullCalendarApiFunction={fullCalendarApiFunction}
                                    calendarDate={calendarDate}
                                    setCalendarDate={setCalendarDate}
                                    changeCalendarView={changeCalendarView}
                                    removeRightIcons
                                    isDropDownDisable={isCustomeDateSelected}
                                    customeTitleComponent={
                                        isCustomeDateSelected ? <React.Fragment>
                                            <Header as={'h3'} className="CalendarToolbar__Header">
                                                {paramDateRange}
                                                <Icon link className='fa-solid fa-times' onClick={() => {
                                                    setDateRange(" - ");
                                                    navigate("/")
                                                }} />
                                            </Header>
                                        </React.Fragment> : undefined
                                    }
                                    isForceEnableRighButton={isCustomeDateSelected}
                                />
                            </span>
                        </div>
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column>
                        {activeTab === 0 && <PhoneSystemDashboard startTime={startTime} endTime={endTime} />}
                        {activeTab === 1 && <SalesDashboard startTime={startTime} endTime={endTime} />}
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <TimestampFilters
                title={"Select Date"}
                timestamp={timestamp}
                onToggleTimeUnit={(timestamp) =>
                    onToggleTimeUnit(
                        timestamp,
                        setTimestamp,
                        params,
                        navigate,
                        ""
                    )
                }
                isCustomDateRangeOpen={isCustomDateRangeOpen}
                onOpenCustomDateRange={() => {
                    setCustomDateRangeOpen(true);
                    setDateRange('');
                }}
                onCloseCustomDateRange={() => {
                    setCustomDateRangeOpen(false);
                }}
                dateRange={dateRange}
                onDateRangeChange={onDateRangeChange}
                getData={() =>
                    getData({
                        setCustomDateRangeOpen,
                        dateRange,
                        userAuthTimezone,
                        params,
                        navigate,
                        url: "",
                    })
                }
                noTrigger
            />
        </div>
    );
};

export default Dashboard;
